import { TripInfoSection } from "./trip-info";
import { TripCostEstimation } from "./trip-cost-estimation";
import { TripCost } from "./trip-cost";
import { Container } from "./styles";
import { DestinationPicture } from "./destination-picture";
import { useShowTripCost } from "screens/offer-bc/utils";

export const TripSummary = () => {
  const showTripCost = useShowTripCost();

  return (
    <Container>
      <DestinationPicture />
      <TripInfoSection />
      {showTripCost && <TripCostEstimation />}
      <TripCost />
    </Container>
  );
};
